const areas = ['series', 'dimensions', 'breakdowns', 'size', 'x', 'y'] as const;
const dimensions = ['dimensions', 'breakdowns'] as const;

export type DropAreaTypeModel = (typeof areas)[number];
export type DimensionModel = (typeof dimensions)[number];

export function isDropAreaType(input: string): input is DropAreaTypeModel {
  return (areas as unknown as string[]).includes(input);
}
export function isDimension(input: string): input is DropAreaTypeModel {
  return (dimensions as unknown as string[]).includes(input);
}
